export const getMimeImageType = (filename: string) => {
  const parts: string[] = filename.split(".");
  const extension = parts.pop()?.toLowerCase() || "";

  const mimeTypes: Record<string, string> = {
    webp: " image/webp",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    bmp: "image/bmp",
    ico: "image/x-icon",
    pdf: "application/pdf",
  };
  return { mimeType: mimeTypes[extension] || "", isPdf: extension === "pdf" };
};
